import BaseOption from "%/dynamic-component-editor/classes/base-option";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";

// Per-instance required-context remap ({ requiredName: sourceContextName }); also
// the model for the full-width Component Binding / Required Context inspector section.
export default class ContextBindings extends BaseOption {
  static defaultValue = {};

  static userInterfaceComponent = () => ({
    useCustomLabel: true,
    useVerticalOrientation: true,
    label: "Component Binding",
    component: inspectorTools.COMPONENT_CONTEXT_BINDINGS,
  });
}
